import { render } from "./PropertyDetails.vue?vue&type=template&id=73ce3f4e&scoped=true&ts=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=ts"
export * from "./PropertyDetails.vue?vue&type=script&lang=ts"

import "./PropertyDetails.vue?vue&type=style&index=0&id=73ce3f4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ce3f4e"]])

export default __exports__